import Api from "../../api.service";
import store from "../";
const state = {
    latestAds: [],
    latestOffers:[],
    latestNotifications:[],
    shopsCount:0,
    shopsWithMapCount:0,
    categoriesCount:0,
    mobileUsersCount:0
};
const getters = {
    latestAds(state)
    {
        return state.latestAds;
    },
    latestOffers(state)
    {
        return state.latestOffers;
    },
    latestNotifications(state)
    {
        return state.latestNotifications;
    },
    shopsCount(state)
    {
        return state.shopsCount;
    },
    shopsWithMapCount(state)
    {
        return state.shopsWithMapCount;
    },
    categoriesCount(state)
    {
        return state.categoriesCount;
    },
    mobileUsersCount(state)
    {
        return state.mobileUsersCount;
    },
};
const mutations = {
    GET_HOME_STATS(state,payload)
    {
        console.log(payload)
        state.latestAds = payload.latestAds;
        state.latestOffers = payload.latestOffers;
        state.latestNotifications = payload.latestNotifications;
        state.shopsCount = payload.shopsCount;
        state.shopsWithMapCount = payload.shopsWithMapCount;
        state.categoriesCount = payload.categoriesCount;
        state.mobileUsersCount = payload.mobileUsersCount;
        store.dispatch("setLoading", false);
    }
};
const actions = {
    async fetchHome(context,payload)
    {
        store.dispatch("setLoading", true);
        const {data} = await Api.query("/api/Home/GetHomeStats")
                                .then((data)=>data);
        context.commit("GET_HOME_STATS",data)
    }
};
const home = { state, getters, mutations, actions }

export default home;